<template>
  <v-card-text class="pa-5">
    <v-dialog v-model="dialog.detail" scrollable max-width="900">
      <v-card>
        <v-card-title class="background-first body-2 white--text py-1 pl-5 pr-2">
          <span>Detail</span>
          <v-spacer />
          <v-btn color="#0299B7" small elevation="0" fab @click="dialog.detail = false">
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <table width="100%" class="body-2 detail-summary-table">
            <tr>
              <td width="20%">Nama</td>
              <td width="2%">:</td>
              <td>{{ selectedPeriod ? selectedPeriod.nama : "-" }}</td>
            </tr>
            <tr>
              <td>Periode</td>
              <td>:</td>
              <td>{{ selectedPeriod ? selectedPeriod.periode : "-" }}</td>
            </tr>
          </table>

          <div class="color-first subtitle-1 font-weight-bold mt-6 mb-2">
            Pembagian instrument (%)
          </div>
          <table width="100%" class="body-2 detail-summary-table">
            <tr>
              <td width="30%">Persentase default</td>
              <td width="2%">:</td>
              <td>{{ selectedPeriod ? selectedPeriod.instrument_default : "-" }}%</td>
            </tr>
            <tr>
              <td>Instrumen dengan persentase khusus</td>
              <td>:</td>
              <td>{{ selectedPeriod ? selectedPeriod.instrument_special_label : "-" }}</td>
            </tr>
          </table>
          <v-data-table
            :headers="detailInstrumentHeaders"
            :items="selectedPeriod ? selectedPeriod.instrument_special_rows : []"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1 mt-3 detail-table"
          />

          <div class="color-first subtitle-1 font-weight-bold mt-6 mb-2">
            Pembagian sewa lab (%)
          </div>
          <table width="100%" class="body-2 detail-summary-table">
            <tr>
              <td width="30%">Persentase default</td>
              <td width="2%">:</td>
              <td>
                <span v-if="selectedPeriod && selectedPeriod.sewa_mode === 'equal'">
                  Dibagi rata {{ selectedPeriod.sewa_total }}%
                </span>
                <span v-else-if="selectedPeriod">
                  {{ selectedPeriod.sewa_laboran }}% laboran<br />
                  {{ selectedPeriod.sewa_kalab }}% kalab
                </span>
                <span v-else>-</span>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.tambah" persistent max-width="950">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Tambah Presentase Fee</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            @click="dialog.tambah = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <div class="color-first subtitle-1 font-weight-bold mb-2">
            Periode pembayaran
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.nama"
                label="Nama"
                outlined
                dense
                color="#0299B7"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.periode"
                :items="periodOptions"
                label="Periode pembayaran (6 bulan)"
                outlined
                dense
                color="#0299B7"
              />
            </v-col>
          </v-row>

          <v-tabs v-model="form.tab" color="#0299B7">
            <v-tab>Pembagian instrument (%)</v-tab>
            <v-tab>Pembagian sewa lab (%)</v-tab>
          </v-tabs>
          <v-tabs-items v-model="form.tab">
            <v-tab-item>
              <div class="color-first subtitle-2 font-weight-bold mt-5 mb-2">
                Presentase default
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.instrument.defaultPercentage"
                    label="Presentase default (%)"
                    type="number"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
              </v-row>
              <div class="color-first subtitle-2 font-weight-bold mb-2">
                Instrument dengan presentase khusus
              </div>
              <v-row
                v-for="(row, index) in form.instrument.special"
                :key="index"
                align="center"
              >
                <v-col cols="12" md="4">
                  <v-select
                    v-model="row.lab"
                    :items="labOptions"
                    item-text="nama"
                    item-value="id"
                    label="Laboratorium"
                    outlined
                    dense
                    color="#0299B7"
                    @change="loadInstruments(row)"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="row.instrument"
                    :items="row.instruments"
                    item-text="nama"
                    item-value="id"
                    label="Nama instrument"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
                <v-col cols="9" md="3">
                  <v-text-field
                    v-model="row.percentage"
                    label="Presentase khusus (%)"
                    type="number"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
              </v-row>
              <div class="d-flex align-center mt-1 mb-3">
                <v-btn
                  large
                  elevation="3"
                  color="#099a55"
                  class="text-capitalize white--text mr-2"
                  @click="addInstrument"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                  v-if="form.instrument.special.length > 1"
                  large
                  elevation="3"
                  color="red"
                  class="text-capitalize white--text"
                  @click="removeInstrument(form.instrument.special.length - 1)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="color-first subtitle-2 font-weight-bold mt-5 mb-2">
                Periode pembayaran
              </div>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="form.periodeSewa"
                    :items="periodOptions"
                    label="Periode pembayaran (6 bulan)"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
              </v-row>
              <div class="color-first subtitle-2 font-weight-bold mb-2">
                Persentase default antara laboran dan kalab
              </div>
              <v-radio-group v-model="form.sewa.mode" row>
                <v-radio label="Dibagi rata" value="equal" color="#0299B7" />
                <v-radio
                  label="Persentase masing-masing"
                  value="custom"
                  color="#0299B7"
                />
              </v-radio-group>
              <v-row v-if="form.sewa.mode === 'equal'">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.sewa.totalPercentage"
                    label="Presentase total (%)"
                    type="number"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.sewa.laboranPercentage"
                    label="Presentase laboran (%)"
                    type="number"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.sewa.kalabPercentage"
                    label="Presentase kalab (%)"
                    type="number"
                    outlined
                    dense
                    color="#0299B7"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn
            outlined
            class="text-capitalize color-first"
            @click="dialog.tambah = false"
            >Batal</v-btn
          >
          <v-btn
            color="#0299B7"
            class="text-capitalize white--text"
            @click="savePeriod"
            >Simpan</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="color-first title font-weight-bold mt-3">
      Periode Pembayaran
    </div>

    <v-row class="mt-6 mb-2" align="center" justify="space-between">
      <v-col cols="12" md="4" class="py-0">
        <v-btn
          color="#0299B7"
          elevation="0"
          class="text-capitalize white--text"
          @click="addPeriod"
        >
          <v-icon left>mdi-plus</v-icon>
          Tambah
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" class="py-0">
        <v-text-field
          v-model="search"
          outlined
          dense
          clearable
          hide-details
          placeholder="Cari . . ."
          prepend-inner-icon="mdi-magnify"
          color="#0299B7"
        />
      </v-col>
    </v-row>

    <div class="pt-5">
      <v-data-table
        :headers="headers"
        :items="rows"
        :search="search"
        :items-per-page="10"
        class="elevation-1 required periode-payment-table pa-5"
      >
        <template v-slot:[`item.aksi`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                fab
                icon
                color="orange"
                v-bind="attrs"
                v-on="on"
                @click="editPeriod(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Ubah</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                fab
                icon
                color="#0299B7"
                v-bind="attrs"
                v-on="on"
                @click="detailPeriod(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Detail</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </v-card-text>
</template>

<script>
import { get } from "@/service/Axios";

export default {
  data() {
    return {
      dialog: { tambah: false, detail: false },
      search: "",
      selectedPeriod: null,
      detailInstrumentHeaders: [
        { text: "No.", value: "no", sortable: false },
        { text: "Lab", value: "lab", sortable: false },
        { text: "Nama", value: "nama", sortable: false },
        {
          text: "Presentase khusus (%)",
          value: "percentage",
          sortable: false
        }
      ],
      labOptions: [{ id: "all", nama: "Semua" }],
      periodOptions: [
        "Januari 2026 - Juni 2026",
        "Juli 2026 - Desember 2026",
        "Januari 2027 - Juni 2027"
      ],
      form: {
        nama: "",
        periode: "",
        tab: 0,
        periodeSewa: "",
        instrument: {
          defaultPercentage: "",
          special: [
            { lab: "all", instrument: "", percentage: "", instruments: [] }
          ]
        },
        sewa: {
          mode: "equal",
          totalPercentage: "",
          laboranPercentage: "",
          kalabPercentage: ""
        }
      },
      headers: [
        { text: "No.", value: "no", sortable: false },
        { text: "Periode pembayaran", value: "periode", sortable: false },
        {
          text: "Pembagian instrument (%)",
          value: "pembagian_instrument",
          sortable: false
        },
        {
          text: "Instrument dengan presentase khusus",
          value: "instrument_khusus",
          sortable: false
        },
        {
          text: "Pembagian sewa lab (%)",
          value: "pembagian_sewa_lab",
          sortable: false
        },
        {
          text: "Keterangan pembagian sewa lab",
          value: "keterangan_sewa_lab",
          sortable: false
        },
        { text: "Aksi", value: "aksi", align: "center", sortable: false }
      ],
      rows: [
        {
          no: 1,
          nama: "Fee Laboratorium Farmasi 2026",
          periode: "Januari 2026 - Juni 2026",
          pembagian_instrument: "30",
          instrument_khusus: "-",
          pembagian_sewa_lab: "20",
          keterangan_sewa_lab: "Pembagian sewa laboratorium umum",
          instrument_default: "30",
          instrument_special_label: "Ada",
          instrument_special_rows: [
            { no: 1, lab: "Laboratorium Mikrobiologi Farmasi", nama: "Spektrofotometer", percentage: "40" }
          ],
          sewa_mode: "equal",
          sewa_total: "25",
          sewa_laboran: "",
          sewa_kalab: ""
        },
        {
          no: 2,
          nama: "Fee Laboratorium Farmasi Semester 2",
          periode: "Juli 2026 - Desember 2026",
          pembagian_instrument: "35",
          instrument_khusus: "Spektrofotometer (40%)",
          pembagian_sewa_lab: "25",
          keterangan_sewa_lab: "Berlaku untuk penggunaan di luar jam kerja",
          instrument_default: "35",
          instrument_special_label: "Ada",
          instrument_special_rows: [
            { no: 1, lab: "Laboratorium Kimia Farmasi", nama: "HPLC", percentage: "45" }
          ],
          sewa_mode: "custom",
          sewa_total: "",
          sewa_laboran: "15",
          sewa_kalab: "10"
        }
      ]
    };
  },
  mounted() {
    this.loadLabs();
  },
  methods: {
    addPeriod() {
      this.dialog.tambah = true;
    },
    async loadLabs() {
      try {
        const { data, status } = await get("laboratory-master", {
          params: { flag_lainnya: "1" }
        });
        if (status === 200 && data.data) {
          this.labOptions = [
            { id: "all", nama: "Semua" },
            ...data.data.map((lab) => ({
              id: lab.id,
              nama: lab.namaLaboratorium
            }))
          ];
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadInstruments(row) {
      row.instrument = "";
      row.instruments = [];
      if (!row.lab || row.lab === "all") return;
      try {
        const { data, status } = await get("instrument-master", {
          params: { id_laboratorium: row.lab, search: "" }
        });
        if (status === 200 && data.data) {
          row.instruments = data.data.map((instrument) => ({
            id: instrument.kdInstrumen,
            nama: instrument.namaInstrumen
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    addInstrument() {
      this.form.instrument.special.push({
        lab: "all",
        instrument: "",
        percentage: "",
        instruments: []
      });
    },
    removeInstrument(index) {
      this.form.instrument.special.splice(index, 1);
    },
    savePeriod() {
      this.dialog.tambah = false;
      this.$emit("add", this.form);
    },
    editPeriod(item) {
      this.selectedPeriod = item;
      this.$emit("edit", item);
    },
    detailPeriod(item) {
      this.selectedPeriod = item;
      this.dialog.detail = true;
      this.$emit("detail", item);
    }
  }
};
</script>

<style scoped>
.periode-payment-table {
  white-space: nowrap;
}

.periode-payment-table >>> th,
.periode-payment-table >>> td {
  white-space: nowrap;
}

.periode-payment-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
</style>
